import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { round } from '../../../../../../helpers';

// Locks in the value a field was loaded with and, while editing, tracks whether
// the user has since changed it so the form can offer a way back. `useState`'s
// lazy initializer runs once on mount, so this captures the value at form
// load even when it's 0 or null (a plain ref guarded by `if (!current)`
// would mis-fire on falsy originals).
export function useFieldRevert(name: string) {
    const rx = useFormContext();
    const isEditing = !!rx.getValues('id');
    const [original] = useState<unknown>(() => rx.getValues(name));
    const current = useWatch({ name });

    const hasChanged =
        isEditing &&
        original !== null &&
        original !== undefined &&
        round(Number(current)) !== round(Number(original));

    const revert = () => rx.setValue(name, original, { shouldValidate: true });

    return { original, hasChanged, revert };
}
